import { useState } from "react";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";

export function RemoveRoleModals(props: {
  onConfirmRemoveRole: () => Promise<void>;
  showRemoveRoleModal: boolean;
  setShowRemoveRoleModal: (value: boolean) => void;
  roleName: string;
  onMount: () => void;
}) {
  const {
    onConfirmRemoveRole,
    showRemoveRoleModal,
    setShowRemoveRoleModal,
    roleName,
    onMount,
  } = props;
  const [showRemoveRoleSuccesModal, setShowRemoveRoleSuccessModal] =
    useState<boolean>(false);
  const [showRemoveRoleErrorModal, setShowRemoveRoleErrorModal] =
    useState<boolean>(false);
  return (
    <>
      <ConfirmationModal
        contentText={`Deseja realmente remover o perfil ${roleName} ?`}
        open={showRemoveRoleModal}
        onConfirm={onConfirmRemoveRole}
        setOpen={setShowRemoveRoleModal}
        title="Remover Perfil"
        setOpenErrorModal={setShowRemoveRoleErrorModal}
        setOpenSuccessModal={setShowRemoveRoleSuccessModal}
      />
      <ActionAlert
        message="O perfil foi removido com sucesso"
        severity="success"
        open={showRemoveRoleSuccesModal}
        setOpen={setShowRemoveRoleSuccessModal}
        onClose={() => {
          setShowRemoveRoleModal(false);
          onMount();
        }}
      />
      <ActionAlert
        message="Ocorreu um erro ao remover o perfil do usuário"
        severity="error"
        open={showRemoveRoleErrorModal}
        setOpen={setShowRemoveRoleErrorModal}
        onClose={() => {
          setShowRemoveRoleModal(false);
        }}
      />
    </>
  );
}
